<template>
  <!-- <ion-page>
    <ion-header><ion-toolbar></ion-toolbar></ion-header>
    <ion-content> -->
  <div class="c-inteliwise" id="inteliwise-agent"></div>
  <!-- </ion-content>
  </ion-page> -->
</template>

<script>
import {
  modalController,
  // IonPage,
  // IonContent,
  // IonHeader,
  // IonToolbar,
} from "@ionic/vue";

let customData = {};

export default {
  components: {
    // IonPage,
    // IonContent,
    // IonHeader,
    // IonToolbar,
  },
  props: {
    inteliwiseAnswers: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  unmounted() {
    console.log("InteliwiseModal unmountend");

    document.removeEventListener(
      "inteliwiseWidgetReady",
      this.inteliwiseWidgetReady
    );

    const inteliwiseScriptElement = document.getElementById("inteliwiseScript");
    if (inteliwiseScriptElement) {
      inteliwiseScriptElement.remove();
    }
  },
  mounted() {
    console.log("InteliwiseModal mounted");

    localStorage.removeItem(
      "0b56d209329264b0d7c0141b052209010099e47e4dd912cb4110824c33ac6316-664-iw-storage-iframe"
    );

    customData = {
      agentData: [
        {
          title: "Kundeninformationen",
          data: [
            { Vorname: "Max" },
            { Nachname: "Hutter" },
            { Geschlecht: "männlich" },
            { Alter: "27" },
            ...this.inteliwiseAnswers,
          ],
        },
      ],
    };

    document.addEventListener(
      "inteliwiseWidgetReady",
      this.inteliwiseWidgetReady
    );

    const inteliwiseScript = document.createElement("script");
    inteliwiseScript.setAttribute("id", "inteliwiseScript");
    inteliwiseScript.setAttribute(
      "src",
      "https://static.inteliwise.com/embed/0b56d209329264b0d7c0141b052209010099e47e4dd912cb4110824c33ac6316/embed.js"
    );
    document.body.appendChild(inteliwiseScript);
  },
  methods: {
    inteliwiseWidgetReady: (data) => {
      const widget = data.detail.widget;

      widget.events.addListener("message", ({ message }) => {
        console.log(message);
        switch (message.type) {
          case "LC_STARTED":
            console.log(customData);
            widget.sendCustomData(customData);
            console.log("livechat started");
            break;
          case "LC_ENDED":
            console.log("livechat ended");
            setTimeout(() => {
              modalController.dismiss();
            }, 5000);
            break;
          case "LC_TAG_ADDED":
            console.log("livechat tag: ", message.externalId);
            break;
          default:
            console.log("message:", message.type);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-inteliwise {
  height: 100%;
  padding-top: var(--ion-safe-area-top, 0);
  padding-bottom: var(--ion-safe-area-bottom, 0);
  --vh-offset: calc(
    var(--ion-safe-area-top, 0) + var(--ion-safe-area-bottom, 0)
  );
}
</style>
